import { render } from "./InputAmount.vue?vue&type=template&id=64b9674a&scoped=true"
import script from "./InputAmount.vue?vue&type=script&lang=js"
export * from "./InputAmount.vue?vue&type=script&lang=js"

import "./InputAmount.vue?vue&type=style&index=0&id=64b9674a&scoped=true&lang=css"

import exportComponent from "/var/www/html/projects/hetfruit/resources/vueapps/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b9674a"]])

export default __exports__